export default {
  headers: {
    datetime: 'Date and time',
    company: 'Company',
    previous: 'Previous status',
    current: 'Current status',
    consultant: 'Consultant',
    comments: 'Comments'
  },
  title: 'Historical of bill changes.'
}
